import * as React from 'react'
import { useLocation } from '@reach/router'
// import logo from "../../images/las_puertas_de_mazatlan_logo_white.svg";
import logo from '../../images/las_puertas_de_mazatlan_logo_yellow.svg'
import logoHover from '../../images/las_puertas_de_mazatlan_logo_golden.svg'
import 'animate.css'
import {
  Button,
  Container,
  FormControl,
  InputAdornment,
  MenuItem,
  Select,
  SelectChangeEvent
} from '@mui/material'
import MenuSideBar from './menuSideBar'
import { navigate } from 'gatsby-link'
import Submenu, { Menu } from './submenu'
import './navbar.scss'
import { Link } from 'gatsby'
import { useSingleType } from '../../hooks/use-single-type'
import { useTranslation } from 'react-i18next'
import mx from '../../images/mx.png'
import us from '../../images/us.png'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import LogoutIcon from '@mui/icons-material/Logout'

type Props = {
  session: any
  setSession: any
  signUp: () => void
  signIn: () => void
  id: string
  logoImg: any
}

const Navbar: React.FC<Props> = ({
  session,
  setSession,
  signUp,
  signIn,
  id,
  logoImg
}) => {
  /*{
          "id": 3,
          "documentId": "ma82th0q5p3dahw9cnq7mig1",
          "name": "MainMenuNavbar",
          "createdAt": "2024-11-30T01:48:10.564Z",
          "updatedAt": "2024-11-30T02:42:51.288Z",
          "publishedAt": "2024-11-30T02:42:51.355Z",
          "locale": "en",
          "mainMenu": [
              {
                  "__component": "menu.menu-link",
                  "id": 11,
                  "name": "Inicio",
                  "path": "/",
                  "targetBlank": false
              },
              // {
              //     "__component": "menu.submenu",
              //     "id": 3,
              //     "name": "Precios",
              //     "path": null,
              //     "targetBlank": false,
              //     "submenu": {
              //         "id": 5,
              //         "documentId": "yjzcj1e4gyzg9sv2s1qqyzzh",
              //         "name": "Precios",
              //         "createdAt": "2024-11-30T01:46:21.688Z",
              //         "updatedAt": "2025-04-11T01:46:16.794Z",
              //         "publishedAt": "2025-04-11T01:46:16.844Z",
              //         "locale": "en",
              //         "links": [
              //             {
              //                 "id": 42,
              //                 "name": "Servicios de Hotel",
              //                 "path": "https://www.bellafer.com",
              //                 "targetBlank": true
              //             },
              //             {
              //                 "id": 43,
              //                 "name": "Lotes de Terreno Residenciales",
              //                 "path": "/lotes#disponibilidad",
              //                 "targetBlank": false
              //             },
              //             {
              //                 "id": 44,
              //                 "name": "Servicios de Construcción (CASAS)",
              //                 "path": "/casas",
              //                 "targetBlank": false
              //             },
              //             {
              //                 "id": 45,
              //                 "name": "Cuotas Plusvalía y Mantenimiento",
              //                 "path": "/cuotas-mantenimiento-plusvalia",
              //                 "targetBlank": false
              //             },
              //             {
              //                 "id": 46,
              //                 "name": "Preguntas y respuestas frecuentes (FAQ)",
              //                 "path": "/faq",
              //                 "targetBlank": false
              //             }
              //         ]
              //     }
              // },
              // {
              //     "__component": "menu.menu-link",
              //     "id": 13,
              //     "name": "Galería",
              //     "path": "/galeria",
              //     "targetBlank": false
              // },
              {
                  "__component": "menu.menu-link",
                  "id": 14,
                  "name": "Nosotros",
                  "path": "#nosotros",
                  "targetBlank": false
              },
              {
                  "__component": "menu.menu-link",
                  "id": 14,
                  "name": "FAQ",
                  "path": "#faq",
                  "targetBlank": false
              },
              {
                  "__component": "menu.menu-link",
                  "id": 15,
                  "name": "Contáctanos",
                  "path": "#contacto",
                  "targetBlank": false
              }
          ],
          "rightMenu": []
      }*/

  const [menu, setMenu] = React.useState<any>([])
  const [lang, setLang] = React.useState<string>()
  const { i18n } = useTranslation()

  const [isComunicados, setIsComunicados] = React.useState<boolean>(false)
  const location = useLocation()

  useSingleType({
    name: 'main-menu',
    population: ['mainMenu.submenu.links', 'rightMenu.submenu.links'],
    onSuccess (result) {
      setMenu(result)
    },
    onError (error) {
      console.log(error)
    },
    onComplete () {}
  })

  function logout () {
    sessionStorage.clear()
    localStorage.clear()
    setSession(false)
  }

  const [datosCliente, setDatosCliente] = React.useState<any>({})
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)

  const openMenu = Boolean(anchorEl)
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (anchorEl) {
      setAnchorEl(null)
      return
    }
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  React.useEffect(() => {
    let DatosClienteSession = sessionStorage?.getItem('datosCliente')
    if (DatosClienteSession && DatosClienteSession !== 'null') {
      setDatosCliente(JSON.parse(DatosClienteSession).DatosCliente)
    }

    setLang(localStorage.getItem('lang') || 'es')

    if (['/comunicados/'].includes(location.pathname)) {
      setIsComunicados(true)
    } else {
      setIsComunicados(false)
    }
  }, [session, location])

  const handleChangeLang = (event: SelectChangeEvent) => {
    let lang = event.target.value
    i18n.changeLanguage(lang)
    localStorage.setItem('lang', lang)
    setLang(lang)
  }

  // agrega/quita estilo al hacer scroll
  const [scrolled, setScrolled] = React.useState(false)
  React.useEffect(() => {
    // const onScroll = () => setScrolled(window.scrollY > 10);
    // onScroll();
    // window.addEventListener("scroll", onScroll, { passive: true });
    // return () => window.removeEventListener("scroll", onScroll);
  }, [])

  const isHome = location.pathname === '/'
  const [isHover, setIsHover] = React.useState(false)

  return (
    <nav id={id}>
      <Container maxWidth='xxl'>
        <div className='navbarContainer'>
          <Link
            to='/'
            onMouseEnter={() => setIsHover(true)}
            onMouseLeave={() => setIsHover(false)}
          >
            {/* <img src={logoImg?.url ? logoImg?.url : logo } alt="Puntazul Residencial" id="nav-logo" /> */}
            <img
              src={logo}
              alt="Las Puertas D' Mazatlán"
              style={{ height: 'clamp(40px, 6vw, 70px)' }}
            />
          </Link> 
          <section>
            <menu style={{ padding: 0 }} className='mainMenu'>
              {menu?.mainMenu?.map((menuItem: any, index: number) => (
                <div className='menuItem initialMenuItem' key={index}>
                  {menuItem.submenu ? (
                    <>
                      <Button className='nav-button'>{menuItem.name}</Button>
                      <Submenu menuItems={menuItem.submenu.links} />
                    </>
                  ) : (
                    <Link className='nav-button'  to={menuItem.path} target={menuItem.targetBlank ? '_blank' : '_self' }   activeClassName={'itemMenuActive'} >
                      {/* <Button className='nav-button' style={{ height: '100%' }}>
                        <p> */}
                          {menuItem.name}
                          {/* </p> 
                      </Button> */}
                    </Link>
                  ) 
                  // : (
                  //   <Link to={menuItem.path}  activeClassName={'itemMenuActive'} >
                  //   <button
                  //     // onClick={() => {
                  //     //   navigate(menuItem.path)
                  //     // }}
                  //     className='nav-button custom-button'
                  //   >
                  //    <p>
                  //     {menuItem.name}
                  //     </p> 
                  //   </button>
                  //    </Link>
                  // )
                  }
                </div>
              ))}
              {menu?.mainMenu?.length > 4 && (
                <div className='menuItem masMenuItem'>
                  <Button className='nav-button'>Más</Button>
                  <Submenu menuItems={menu?.mainMenu?.slice(4)} />
                </div>
              )}
            </menu>
          </section>
          {lang && isComunicados && (
            <FormControl sx={{ m: 1 }} size='small' className='langSelect'>
              <Select
                variant='standard'
                id='language-select'
                value={lang}
                onChange={handleChangeLang}
                MenuProps={{
                  disableScrollLock: true // Evita bloquear el scroll del body
                }}
                startAdornment={
                  <InputAdornment position='start'>
                    <img src={lang === 'es' ? mx : us} alt='test' width={20} />
                  </InputAdornment>
                }
                aria-controls='language-menu'
              >
                <MenuItem value='es'>ES</MenuItem>
                <MenuItem value='en'>EN</MenuItem>
              </Select>
            </FormControl>
          )}
          <MenuSideBar
            menuItems={menu?.mainMenu?.concat(menu?.rightMenu)}
            session={session}
            setSession={setSession}
            signIn={signIn}
            signUp={signUp}
          />
          <section
            className='leftMenu'
            style={{ display: 'flex', alignItems: 'center' }}
          >
            <menu style={{ padding: 0 }}>
              {menu?.rightMenu?.map((menuItem: any, index: number) => (
                <div className='menuItem' key={index}>
                  {menuItem.targetBlank ? (
                    <a href={menuItem.path} target='_blank'>
                      <Button className='nav-button' style={{ height: '100%' }}>
                        {menuItem.name}
                      </Button>
                    </a>
                  ) : (
                    <Button
                      onClick={() => {
                        navigate(menuItem.path)
                      }}
                      className='nav-button'
                    >
                      {menuItem.name}
                    </Button>
                  )}
                </div>
              ))}
              {lang && isComunicados && (
                <FormControl sx={{ m: 1 }} size='small'>
                  <Select
                    variant='standard'
                    id='language-select'
                    value={lang}
                    onChange={handleChangeLang}
                    MenuProps={{
                      disableScrollLock: true // Evita bloquear el scroll del body
                    }}
                    startAdornment={
                      <InputAdornment position='start'>
                        <img
                          src={lang === 'es' ? mx : us}
                          alt='test'
                          width={20}
                        />
                      </InputAdornment>
                    }
                    aria-controls='language-menu'
                  >
                    <MenuItem value='es'>Español</MenuItem>
                    <MenuItem value='en'>English</MenuItem>
                  </Select>
                </FormControl>
              )}
              {session ? (
                <Button
                  className='nav-button loginButton'
                  style={{ alignSelf: 'center', color: 'white !important' }}
                  onClick={logout}
                  size='small'
                  variant='contained'
                  disableElevation
                  startIcon={<LogoutIcon />}
                >
                  Cerrar Sesión
                </Button>
              ) : (
                <Button
                  className='nav-button loginButton'
                  style={{ color: 'white !important' }}
                  onClick={signIn}
                  size='small'
                  variant='contained'
                  disableElevation
                  startIcon={<AccountCircleIcon />}
                >
                  Login
                </Button>
              )}
            </menu>
          </section>
        </div>
      </Container>
    </nav>
  )
}

export default Navbar
